/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CalculateBmiDto } from '../models/CalculateBmiDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ExpertAppBmiCalculatorService {
    /**
     * Calculate and save BMI
     * Calculates BMI from height/weight inputs, categorizes it, and saves to expert BMI history.
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public static bmiControllerCalculateBmiV1(
        requestBody: CalculateBmiDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/expert-app/bmi',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get BMI history
     * Returns the latest BMI record plus paginated history, ordered by most recent.
     * @param pageNo Page number
     * @param pageSize Items per page
     * @returns any
     * @throws ApiError
     */
    public static bmiControllerGetBmiHistoryV1(
        pageNo: number = 1,
        pageSize: number = 10,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/expert-app/bmi',
            query: {
                'pageNo': pageNo,
                'pageSize': pageSize,
            },
        });
    }
}
